var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { Animation } from '@progress/kendo-react-animation';
import { validatePackage, Navigation, FOCUSABLE_ELEMENTS, classNames } from '@progress/kendo-react-common';
import { packageMetadata } from '../package-metadata';
import { ActionSheetItem } from './ActionSheetItem';
import { headerDisplayName } from './ActionSheetHeader';
import { footerDisplayName } from './ActionSheetFooter';
import { contentDisplayName } from './ActionSheetContent';
/**
 * Represents the [KendoReact ActionSheet]({% slug overview_actionsheet %}) component.
 */
var ActionSheet = /** @class */ (function (_super) {
    __extends(ActionSheet, _super);
    /** @hidden */
    function ActionSheet(props) {
        var _this = _super.call(this, props) || this;
        _this.actionSheetRef = React.createRef();
        _this.actionSheetTitleClass = 'k-actionsheet-title';
        _this.ariaLabeledBy = _this.actionSheetTitleClass + 1;
        _this.animationDuration = 300;
        _this.bottomPosition = { bottom: '0', width: '100%' };
        _this.handleKeyDown = function (e) {
            if (_this.props.navigatable) {
                _this.navigation.triggerKeyboardEvent(e);
            }
        };
        _this.onTab = function (target, nav, ev) {
            ev.preventDefault();
            if (ev.shiftKey) {
                nav.focusPrevious(target);
            }
            else {
                nav.focusNext(target);
            }
        };
        _this.handleOverlayClick = function (ev) {
            /** Deprecated */
            if (_this.props.onOverlayClick) {
                _this.props.onOverlayClick.call(undefined, ev);
            }
            if (_this.props.onClose) {
                _this.props.onClose.call(undefined, ev);
            }
            if (!_this.props.animation) {
                _this.hideActionSheet();
            }
        };
        _this.handleItemClick = function (ev) {
            /** Deprecated */
            if (_this.props.onItemClick) {
                _this.props.onItemClick.call(undefined, ev);
            }
            if (_this.props.onItemSelect) {
                _this.props.onItemSelect.call(undefined, ev);
            }
            if (!_this.props.animation) {
                _this.hideActionSheet();
            }
        };
        _this.onEnter = function (target, nav, ev) {
            if (target.ariaDisabled) {
                return;
            }
            var isItem = target.className && target.className.indexOf('k-actionsheet-item') !== -1;
            var allItems = nav.elements.filter(function (e) { return e.className.indexOf('k-actionsheet-item') !== -1; });
            /** Deprecated */
            if (isItem && _this.props.onItemClick) {
                ev.preventDefault();
                var item = _this.props.items[allItems.indexOf(target)];
                _this.props.onItemClick.call(undefined, {
                    syntheticEvent: ev,
                    item: item,
                    title: item && item.title
                });
            }
            if (isItem && _this.props.onItemSelect) {
                ev.preventDefault();
                var item = _this.props.items[allItems.indexOf(target)];
                _this.props.onItemSelect.call(undefined, {
                    syntheticEvent: ev,
                    item: item,
                    title: item && item.title
                });
            }
            if (!_this.props.animation) {
                _this.hideActionSheet();
            }
        };
        _this.onEscape = function (_target, _nav, ev) {
            /** Deprecated */
            if (_this.props.onOverlayClick) {
                ev.preventDefault();
                _this.props.onOverlayClick.call(undefined, ev);
            }
            if (_this.props.onClose) {
                ev.preventDefault();
                _this.props.onClose.call(undefined, ev);
            }
            if (!_this.props.animation) {
                _this.hideActionSheet();
            }
        };
        _this.hideActionSheet = function () {
            _this.setState({ show: false });
        };
        _this.children = function (children) {
            var components = {};
            React.Children.forEach(children, function (child) {
                if (child) {
                    components[child.type.displayName] = child;
                }
                ;
            });
            return components;
        };
        _this.state = {
            show: false,
            slide: false
        };
        validatePackage(packageMetadata);
        return _this;
    }
    /** @hidden */
    ActionSheet.prototype.componentDidMount = function () {
        if (this.props.expand && !this.state.show) {
            this.setState({ show: true });
        }
    };
    /** @hidden */
    ActionSheet.prototype.componentDidUpdate = function (_prevProps, prevState) {
        var _this = this;
        var currentRef = this.actionSheetRef.current;
        if (this.props.expand && !this.state.show) {
            this.setState({ show: true });
        }
        if (this.props.expand && this.state.show && !this.state.slide) {
            this.setState({ slide: true });
        }
        if (!this.props.expand && this.state.show && this.state.slide) {
            this.setState({ slide: false });
        }
        if (prevState !== this.state && this.state.slide && currentRef && !this.props.className) {
            currentRef.style.setProperty('--kendo-actionsheet-height', 'auto');
            currentRef.style.setProperty('--kendo-actionsheet-max-height', 'none');
        }
        if (currentRef) {
            if (this.props.navigatable) {
                var innerElements = [
                    '.k-actionsheet-footer',
                    '.k-actionsheet-content',
                    '.k-actionsheet-titlebar'
                ].map(function (selector) {
                    return FOCUSABLE_ELEMENTS.concat(_this.props.navigatableElements).map(function (focusableSelector) { return "".concat(selector, " ").concat(focusableSelector); });
                });
                var selectors = __spreadArray([
                    '.k-actionsheet-item'
                ], innerElements.flat(), true);
                this.navigation = new Navigation({
                    tabIndex: this.props.tabIndex || 0,
                    root: this.actionSheetRef,
                    rovingTabIndex: false,
                    selectors: selectors,
                    keyboardEvents: {
                        keydown: {
                            'Tab': this.onTab,
                            'Enter': this.onEnter,
                            'Escape': this.onEscape
                        }
                    }
                });
                this.navigation.focusElement(this.navigation.first, null);
            }
        }
    };
    ;
    /** @hidden */
    ActionSheet.prototype.render = function () {
        var _this = this;
        var _a = this.props, title = _a.title, subTitle = _a.subTitle, animationStyles = _a.animationStyles, animation = _a.animation, expand = _a.expand, tabIndex = _a.tabIndex, items = _a.items;
        var topGroupItems = items === null || items === void 0 ? void 0 : items.filter(function (item) { return !item.group || item.group === 'top'; });
        var bottomGroupItems = items === null || items === void 0 ? void 0 : items.filter(function (item) { return item.group === 'bottom'; });
        var shouldRenderSeparator = (topGroupItems && topGroupItems.length > 0) && (bottomGroupItems && bottomGroupItems.length > 0);
        var children = this.children(this.props.children);
        var animationDuration = this.props.animationDuration || this.animationDuration;
        var actionSheetPanel = this.state.slide && React.createElement("div", { className: classNames('k-actionsheet', this.props.className, {
                'k-actionsheet-bottom': !this.props.className
            }), role: "dialog", "aria-modal": "true", "aria-hidden": false, "aria-labelledby": this.ariaLabeledBy, ref: this.actionSheetRef, onKeyDown: this.handleKeyDown },
            (children[headerDisplayName] && !title && !subTitle) && children[headerDisplayName],
            (title || subTitle) && (React.createElement("div", { className: "k-actionsheet-titlebar k-text-center" },
                React.createElement("div", { className: "k-actionsheet-titlebar-group k-hbox" },
                    React.createElement("div", { className: this.actionSheetTitleClass, id: this.ariaLabeledBy },
                        title && React.createElement("div", null, title),
                        subTitle && React.createElement("div", { className: "k-actionsheet-subtitle" }, subTitle))))),
            children[contentDisplayName] || React.createElement("div", { className: "k-actionsheet-content" },
                React.createElement("div", { className: "k-list-ul", role: "group" }, topGroupItems && topGroupItems.map(function (item, idx) {
                    return (React.createElement(ActionSheetItem, __assign({}, item, { id: idx, key: idx, item: item, tabIndex: tabIndex || 0, onClick: _this.handleItemClick })));
                })),
                shouldRenderSeparator && React.createElement("hr", { className: "k-hr" }),
                React.createElement("div", { className: "k-list-ul", role: "group" }, bottomGroupItems && bottomGroupItems.map(function (item, idx) {
                    return (React.createElement(ActionSheetItem, __assign({}, item, { id: idx + ((topGroupItems === null || topGroupItems === void 0 ? void 0 : topGroupItems.length) || 0), key: idx, item: item, tabIndex: tabIndex || 0, onClick: _this.handleItemClick })));
                }))),
            children[footerDisplayName]);
        return (React.createElement(React.Fragment, null, expand || this.state.show ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "k-actionsheet-container" },
                React.createElement("div", { className: "k-overlay", onClick: this.handleOverlayClick }),
                animation ? React.createElement(Animation, { transitionName: this.state.slide ? 'slide-up' : 'slide-down', onExited: this.hideActionSheet, transitionEnterDuration: animationDuration, transitionExitDuration: animationDuration, animationEnteringStyle: animationStyles || this.bottomPosition, animationEnteredStyle: animationStyles || this.bottomPosition, animationExitingStyle: animationStyles || this.bottomPosition, exit: true, enter: true, appear: false }, actionSheetPanel)
                    : actionSheetPanel)))
            : null));
    };
    ;
    /** @hidden */
    ActionSheet.displayName = 'KendoReactActionSheet';
    /** @hidden */
    ActionSheet.propTypes = {
        items: PropTypes.array,
        subTitle: PropTypes.string,
        title: PropTypes.string,
        navigatable: PropTypes.bool,
        navigatableElements: PropTypes.array
    };
    /** @hidden */
    ActionSheet.defaultProps = {
        navigatable: true,
        navigatableElements: []
    };
    return ActionSheet;
}(React.Component));
export { ActionSheet };
;
